module.exports = __webpack_public_path__ + "static/media/register_icon.c9a53ff2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/register_icon.svg
// module id = 131
// module chunks = 0